import React, { useContext, useEffect } from "react";
import { Formik, Form } from "formik";
import { Context } from "../inc/state";
import { Actions, DisplayFormikState } from "./fields";

// Import React FilePond
import { FilePond, File, registerPlugin } from "react-filepond";
// import FilePondPluginFileRename from "filepond-plugin-file-rename";
import "filepond/dist/filepond.min.css";

// registerPlugin(FilePondPluginFileRename);

export default () => {
	const [state, dispatch, setLoading] = useContext(Context);
	const { values, fundOption, files } = state;

	const handleSubmit = (values, { setSubmitting }) => {
		dispatch({ type: "ADD_DATA", payload: { values } });
		dispatch({ type: "STEP_FORWARD" });
	};
	const updateFiles = (files) => {
		dispatch({ type: "UPDATE_FILES", files });
	};

	let documents = [];

	if (fundOption === 2 || fundOption === 3 || fundOption === 4) {
		if (values.individuals.length) {
			values.individuals.forEach((item, index) => {
				index++;

				const label =
					values.individuals.length === 1
						? `Kopie van de identiteitskaart (voor -en achterzijde)`
						: `Kopie van de identiteitskaart van partner ${index} (voor -en achterzijde)`;

				documents.push({
					name: `identiteitskaart_${index}`,
					label: label,
					allowMultiple: true,
				});
			});
		}
	}

	if (fundOption === 1) {
		documents = [
			{ name: "kbo_uittreksel", label: "KBO uittreksel" },
			{ name: "statuten_vennootschap", label: "Gecoördineerde statuten van de vennootschap" },
			{ name: "ubo_uittreksel", label: "UBO uittreksel" },
			{
				name: "identiteitskaart_bestuurders",
				label: "Kopie van de identiteitskaart van de bestuurders (voor -en achterzijde)",
				allowMultiple: true,
			},
			{
				name: "identiteitskaart_ubo",
				label: "Kopie van de identiteitskaart van de UBO’s (voor -en achterzijde)",
				allowMultiple: true,
			},

			// {
			// 	name: "benoemingsbesluit_van_de_bestuurders_zaakvoerders",
			// 	label: "Benoemingsbesluit van de bestuurders/zaakvoerders (of publicatie daarvan)",
			// 	allowMultiple: true,
			// },
		];

		values.companies[0].legalRepresentatives.forEach((item, index) => {
			index++;
			documents.push({
				name: `benoemingsbesluit_van_de_bestuurders_zaakvoerders_${index}`,
				label: `Benoemingsbesluit van de bestuurders/zaakvoerders ${index} (of publicatie daarvan)`,
				allowMultiple: true,
			});
		});
	}

	if (fundOption === 5) {
		documents = [
			{ name: "kbo_uittreksel", label: "KBO uittreksel" },
			{ name: "statuten_vennootschap", label: "Gecoördineerde statuten van de vennootschap" },
			{ name: "ubo_uittreksel", label: "UBO uittreksel" },

			{ name: "matenregister_maatschap", label: "Kopie van het matenregister" },
		];

		if (values.companies.length > 1) {
			documents.push({
				name: "benoemingsbesluit_van_de_vertegenwoordigers",
				label: "Benoemingsbesluit van de vertegenwoordigers (of publicatie daarvan)",
			});

			values.companies.forEach((item, index) => {
				index++;

				const arr = { label: `Maat ${index}`, documents: [] };

				arr.documents.push({
					name: `identiteitskaart_bestuurders_${index}`,
					label: `Kopie van de identiteitskaart (voor –en achterzijde)`,
					allowMultiple: true,
				});

				if ("Ja" === item.legalRepresentatives[0].isUBOMaatschap) {
					arr.documents.push({
						name: `identiteitskaart_ubo_${index}`,
						label: `Kopie van de identiteitskaart van de UBO’s (voor –en achterzijde))`,
						allowMultiple: true,
					});
				}

				documents.push(arr);
			});
		} else {
			documents.push(
				{
					name: "identiteitskaart_bestuurders",
					label:
						"Kopie van de identiteitskaart van de bestuurders (voor -en achterzijde)",
					allowMultiple: true,
				},
				{
					name: "identiteitskaart_ubo",
					label: "Kopie van de identiteitskaart van de UBO’s (voor -en achterzijde)",
					allowMultiple: true,
				},
				{
					name: "benoemingsbesluit_van_de_vertegenwoordigers",
					label: "Benoemingsbesluit van de vertegenwoordigers (of publicatie daarvan)",
				}
			);
		}
	}

	const initialValues = values;

	return (
		<Formik initialValues={initialValues} onSubmit={handleSubmit}>
			{({ values, setFieldValue }) => {
				return (
					<Form>
						<h4 className="mb-4">Uploaden van documenten</h4>

						<p className="small">
							Upload documenten met de extensie png, jpg, jpeg, pdf, doc of docx.
						</p>

						<p className="small">
							Voeg item per item toe. Indien meerdere items toegelaten zijn dan krijg
							je de optie om opnieuw bestanden toe te voegen.
						</p>

						{documents.map((document, index) => {
							const isGroup = "documents" in document;
							const items = isGroup ? document.documents.map((i) => i) : [document];

							return (
								<div key={`document${index}`}>
									{isGroup && <strong>{document.label}</strong>}
									{items.map((item) => {
										const allowMultiple = item.allowMultiple ? true : false;
										const maxFiles = allowMultiple ? 2 : 1;
										return (
											<div className="file-field" key={item.name}>
												<label htmlFor={item.name} className="form-label">
													{item.label}
												</label>

												<FilePond
													id={item.name}
													files={files[item.name]}
													onupdatefiles={(fileItems) => {
														files[item.name] = fileItems.map(
															(fileItem) => ({
																source: fileItem.file,
																options: { type: "limbo" },
															})
														);
														values.files[item.name] = fileItems.map(
															(fileItem) => fileItem.file.name
														);
														updateFiles(files);
														setFieldValue("files", values.files);
													}}
													onprocessfile={(error, fileItem) => {
														if (typeof fileItem.serverId === "string") {
															const arr = values.uploads;

															if (!arr[item.name]) {
																arr[item.name] = [];
															}

															arr[item.name] = [
																...arr[item.name],
																fileItem.serverId,
															];

															setFieldValue("uploads", arr);
														}
													}}
													maxFiles={maxFiles}
													allowMultiple={allowMultiple}
													server={process.env.REACT_APP_API_URL}
													labelIdle={`Versleep uw bestanden of <span class="filepond--label-action">Blader</span>`}
												/>
											</div>
										);
									})}
								</div>
							);
						})}

						<div className="section">
							<div className="p-3 bg-light small">
								U mag deze documenten ook op een later tijdstip doormailen naar
								gp@integra.fund
							</div>
						</div>

						<Actions />
					</Form>
				);
			}}
		</Formik>
	);
};
